import { X, Circle } from 'lucide-react';
import { useEditorStore } from '../../stores/editorStore';

export function TabBar() {
  const { openTabs, activeTabId, setActiveTab, closeTab, files } = useEditorStore();

  const getLanguageIcon = (language: string) => {
    // Simple color coding based on language
    const colors: Record<string, string> = {
      'csharp': 'text-purple-500',
      'javascript': 'text-yellow-500',
      'typescript': 'text-blue-500',
      'html': 'text-orange-500',
      'css': 'text-blue-400',
      'json': 'text-yellow-600',
      'python': 'text-green-500',
      'java': 'text-red-500',
      'markdown': 'text-gray-500',
    };

    return colors[language?.toLowerCase()] || 'text-gray-500';
  };

  if (openTabs.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 overflow-x-auto">
      {openTabs.map((tab) => {
        const file = files.find(f => f.id === tab.fileId);
        const isActive = activeTabId === tab.fileId;
        const languageColor = getLanguageIcon(tab.language);

        return (
          <div
            key={tab.fileId}
            className={`flex items-center px-3 py-2 border-r border-gray-200 dark:border-gray-700 cursor-pointer min-w-0 ${
              isActive
                ? 'bg-white dark:bg-gray-900 border-b-2 border-b-blue-500'
                : 'hover:bg-gray-100 dark:hover:bg-gray-700'
            }`}
            onClick={() => setActiveTab(tab.fileId)}
          >
            <Circle className={`w-3 h-3 mr-2 ${languageColor}`} />
            <span className="text-sm truncate max-w-xs">
              {tab.name}
              {file?.isDirty && <span className="text-blue-500 ml-1">●</span>}
            </span>
            <button
              className="ml-2 p-0.5 hover:bg-gray-200 dark:hover:bg-gray-600 rounded"
              onClick={(e) => {
                e.stopPropagation();
                closeTab(tab.fileId);
              }}
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        );
      })}
    </div>
  );
}